import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { Card } from 'semantic-ui-react'

import { useParams } from "react-router";

import { format } from 'date-fns'
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { SG_FETCH_EMPLOYEE_RECORD } from "constants/actions";
// 
//
const Details = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [briefResponse, setBriefResponse] = useState(null);

  useEffect(() => {
    if (id) {
      dispatch({
        type: SG_FETCH_EMPLOYEE_RECORD,
        payload: {id}
      });
    }
  }, [dispatch, id]);

  const { get_employee_record } = useSelector(
    (state) => ({
      get_employee_record: state.employee_record,
    }),
    shallowEqual
  );

  useEffect(() => {
    setBriefResponse(get_employee_record?.[id])
  }, [get_employee_record, id]);

// console.log(briefResponse)
  return (
    <PageDiv>
      <Card fluid >
        <Card.Content>
          <Container>
            <ListContainer>
              <HeaderDiv>Employee Id
              </HeaderDiv>
              <ContentDiv>
                {briefResponse?.employee}
              </ContentDiv>
            </ListContainer>
            <ListContainer>
              <HeaderDiv>Status
              </HeaderDiv>
              <ContentDiv>
                {briefResponse?.status}
              </ContentDiv>
            </ListContainer>

            <ListContainer>
              <HeaderDiv>Created Date</HeaderDiv>
              <ContentDiv>
                {briefResponse?.created_at && format(new Date(briefResponse?.created_at), 'dd-MMM-yyyy hh:mm')}
              </ContentDiv>
            </ListContainer>
          </Container>
          <Container>
            <ListContainer>
              <HeaderDiv>Response</HeaderDiv>
              <ContentDiv>
                <pre>
                  {JSON.stringify(briefResponse, null, 2)}
                </pre>
              </ContentDiv>
            </ListContainer>
          </Container>
          <Container>

          </Container>
        </Card.Content>
      </Card>

    </PageDiv>
  );
};

export default Details;

const Container = styled.div`
  display: flex;
`
const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`

const HeaderDiv = styled.div`
  // background-color: #b6701e;
  font-weight: bold;
`

const ContentDiv = styled.div`
  // background-color: #b6701e;

`

const PageDiv = styled.div`
margin-top: 50px;
`